import { render, staticRenderFns } from "./FacilityHistoricalData.vue?vue&type=template&id=1742bf11&scoped=true"
import script from "./FacilityHistoricalData.vue?vue&type=script&lang=js"
export * from "./FacilityHistoricalData.vue?vue&type=script&lang=js"
import style0 from "./FacilityHistoricalData.vue?vue&type=style&index=0&id=1742bf11&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1742bf11",
  null
  
)

export default component.exports